/* eslint camelcase: 0 */
const API_URL = process.env.REACT_APP_API_URL;

export const resources = {
  application: {
    plural: "applications"
  },
  application_accepted: {
    plural: "applications/accepted"
  },
  challenge: {
    plural: "challenges"
  },
  challenges_application: {
    name: "ChallengeApplications",
    plural: "challenges/applications"
  },
  challenges_participant: {
    name: "ChallengeParticipants",
    plural: "challenges/participants"
  },
  company: {
    plural: "companies"
  },
  education: {
    plural: "educations"
  },
  forgot_password: {
    plural: "forgot-passwords"
  },
  demographic: {
    plural: "demographics"
  },
  interview: {
    plural: "interviews"
  },
  job: {
    plural: "jobs"
  },
  profile: {
    plural: "profiles"
  },
  reset_password: {
    plural: "reset-passwords"
  },
  session: {
    plural: "sessions"
  },
  team: {
    plural: "teams"
  },
  user: {
    plural: "users"
  },
  users_team: {
    plural: "teams/members"
  },
  client: {
    plural: "clients"
  },
  notification: {
    plural: "notifications"
  },
  adminInvitation: {
    name: "AdminInvitation",
    plural: "AdminInvitation"
  },
};

Object.keys(resources).forEach(key => {
  let resource = resources[key];
  resource.url = `${API_URL}/${resource.plural}`;
  let name = resource.plural;
  if (resource.name) {
    name = resource.name;
  }
  resource.name = name;
});

export default resources;



// WEBPACK FOOTER //
// ./src/constants/resources.js